import { Backend } from '@/_axios';

export default {
  user() {
    return Backend.get('/users/me');
  },
  // Refresh token
  refresh(token, remember) {
    return Backend.post('auth/refresh', { remember }, { tokenOverride: token });
  },
  login(data) {
    return Backend.post('auth/login', data, { public: true });
  },
  register(data) {
    return Backend.post('auth/register', data);
  },
  forgotPassword(emailData) {
    return Backend.post('auth/forgot-password', emailData);
  },
  resetPassword(resetData) {
    return Backend.put('auth/reset-password', resetData);
  },
};
